"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataLoad = void 0;
const react_1 = require("react");
/**
 * A React hook which wraps a function with loading state.
 *
 * The `loadData` function's returned Promise has additional handlers attached to it to allow this hook
 * to return a loading boolean. Note that this hook *does not* return the loaded data.
 *
 * @param shouldLoad A boolean to control whether the function should be called.
 * @param loadData A function returning the Promise to attach loading state to.
 *
 * @returns loading: boolean of whether the Promise returned by `loadData` is active (not resolved/rejected).
 */
const useDataLoad = (shouldLoad, loadData) => {
    const [loading, setLoading] = (0, react_1.useState)(shouldLoad);
    const [requested, setRequested] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!shouldLoad)
            return;
        if (requested)
            return;
        setRequested(true);
        loadData().catch(() => null).then(() => setLoading(false));
    });
    return loading;
};
exports.useDataLoad = useDataLoad;
//# sourceMappingURL=useDataLoad.js.map